import { ModifyPlanComponent } from "./modify-plan.component";
export const ModifyPlanModule = angular
    .module('modifyPlan', [])
    .component(ModifyPlanComponent.selector, ModifyPlanComponent.component)
    .name;
//# sourceMappingURL=modify-plan.module.js.map